import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { observable, action, autorun } from 'mobx'
import { autobind } from 'core-decorators'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router'

import Loader from '../../shared/components/Loader'
import ErrorContainer from '../../shared/containers/Error'
import FormPage from '../components/FormPage'
import MessageHistory from '../../message/containers/MessageHistory'
import syncTransaction from '../../shared/syncTransaction'

const INITIAL_MESSAGE = (
  <div>
    Zur Zeit gibt es noch keinen Nachrichtenverlauf für
    dieses Programm.
    <br />
    <br />

    Nachdem das Programm gespeichert wurde, wird es einem
    Administrator zur Überprüfung übergeben. Der sämtliche Freigabe-Velauf kann
    danach in dieser Nachrichtenhistorie nachvollzogen werden.
    <br />
    <br />

    Auch Details warum ein Administrator eine Änderung u.U. abgelehnt hat, kann
    dieser Historie entnommen werden.
  </div>
)

@inject('museum', 'program', 'auth') @observer
class FormContainer extends Component {

  /* eslint-disable react/sort-comp */
  @observable isSaving = null

  @observable error = null
  /* eslint-enable react/sort-comp */

  static propTypes = {
    auth: PropTypes.object.isRequired,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
    museum: PropTypes.object.isRequired,
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
    program: PropTypes.object.isRequired,
    router: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
  }

  constructor(props) {
    super(props)
    this.load(props)

    this.dispatch = autorun('add loaded museum', () => {
      const museum = props.museum.current
      const program = props.program.current

      if (program && program.id && museum && museum.id && !program.museum) {
        program.museum = museum
      }
    })
  }

  componentWillUnmount() {
    this.dispatch()
  }

  componentWillReceiveProps(nextProps) {
    this.load(nextProps)
  }

  @autobind
  handleClose() {
    // On close go back to startpage as defined in #65
    this.props.router.push('/')
  }

  @autobind
  handleDelete(model) {
    const method = (
      this.props.auth.acs.isAuthorized('SUPERADMIN,ADMIN')
      || model.isDeactivated
    )
      ? 'destroy'
      : 'deactivate'
    return this::syncTransaction(model[method]())
  }

  @autobind
  handleActivate(model) {
    return this::syncTransaction(model.activate())
  }

  @autobind
  handleSave(model) {
    if (!this.props.program.contains(model)) {
      this.props.program.add(model)
    }

    return this::syncTransaction(model.save())
  }

  @action
  resolveError() {
    this.error = null
  }

  load({
    auth, museum, program, params: { id }
  }) {
    if (!(auth.user && auth.user.museumId)) {
      throw new Error('Method invalid. Missing museum id for program creation action.')
    }

    if (!museum.loading && !(museum.current && museum.current.id)) {
      museum.openById(auth.user.museumId)
    }
    if (!id) {
      program.setCurrent(program.createModel({
        museumId: auth.user.museumId
      }))
    }
    else {
      program.openById(id)
    }
  }

  render() {
    const {
      program,
      program: { current },
      params: { id }
    } = this.props

    if (program.loading) {
      return <Loader>Daten werden geladen</Loader>
    }

    if (
      !current
      || (current.id && current.id !== id * 1)
    ) {
      return <ErrorContainer>Fehler beim Laden</ErrorContainer>
    }

    const canDelete = current.isDeactivated || this.props.auth.acs.isAuthorized('SUPERADMIN,ADMIN')

    return (
      <div className="horizontal">

        <ErrorContainer
          className="error-layer"
          causingComponent={this}
        />

        <FormPage
          current={current}
          canDelete={canDelete}
          onClose={this.handleClose}
          onDelete={this.handleDelete}
          onActivate={this.handleActivate}
          onSave={this.handleSave}
          isBusy={this.isSaving}
        />

        <MessageHistory
          type="program"
          id={id * 1}
          initialMessage={INITIAL_MESSAGE}
        />

      </div>
    )
  }
}

const FormContainerWithRouter = withRouter(FormContainer)

export { FormContainerWithRouter as default }



// WEBPACK FOOTER //
// ./src/program/containers/Form.js